module.exports = __webpack_public_path__ + "static/media/terms_header_img.952b69ee.png";